import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    showNav: PropTypes.bool,
    rootName: PropTypes.string,
    goToFolderView: PropTypes.func.isRequired,
    currentFolder: PropTypes.object,
    parentFolder: PropTypes.object,
    grandParentFolder: PropTypes.object,
};

const defaultProps = {
    className: '',
    showNav: false,
    rootName: 'Channel',
    currentFolder: null,
    parentFolder: null,
    grandParentFolder: null,
};

function FolderBreadcrumbs(props) {
    return (
        <div className={props.className}>
            {!!props.showNav ?
                <div>
                    <button className="bare-text-button" onClick={props.goToFolderView.bind(null, null)}>
                        {props.rootName}
                    </button>
                    {!!props.grandParentFolder &&
                        <span>
                            <span className="fa fa-caret-right margin-left-sm margin-right-sm" aria-hidden="true" />
                            <span className="fa fa-folder margin-right-xs" aria-hidden="true" />
                            <button className="bare-text-button" onClick={props.goToFolderView.bind(null, props.grandParentFolder.id)}>
                                {props.grandParentFolder.name}
                            </button>
                        </span>
                    }
                    {!!props.parentFolder &&
                        <span>
                            <span className="fa fa-caret-right margin-left-sm margin-right-sm" aria-hidden="true" />
                            <span className="fa fa-folder margin-right-xs" aria-hidden="true" />
                            <button className="bare-text-button" onClick={props.goToFolderView.bind(null, props.parentFolder.id)}>
                                {props.parentFolder.name}
                            </button>
                        </span>
                    }
                    {!!props.currentFolder &&
                        <span>
                            <span className="fa fa-caret-right margin-left-sm margin-right-sm" aria-hidden="true" />
                            <span className="fa fa-folder margin-right-xs" aria-hidden="true" />
                            <button className="bare-text-button" disabled>
                                {props.currentFolder.name}
                            </button>
                        </span>
                    }
                </div>
                :
                <span>&nbsp;{/*Preserve parent styling with this blank content*/}</span>
            }
        </div>
    );
}

FolderBreadcrumbs.propTypes = propTypes;
FolderBreadcrumbs.defaultProps = defaultProps;

export default FolderBreadcrumbs;